import { memo, useState, useEffect, useMemo, useCallback, useRef, forwardRef } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { BzButton, BzDropdown, BzTab, BzTabs, BzToolTip } from '../../components';
import {
    BEST5_INDEX, WATCHLIST_GRID_INDEX, SCRIP_INSTRUMENTS, TL_INDEX, DEFAULT_FAVOURITE_INDICES, ORDER_ENTRY_BUTTON_TOGGLE, MARKET_SEGMENT_ID,
    MARKET_OVERVIEW_TABS, FACILITY_NUM, OPTION_CHAIN, GRID_VIEW, MARKET_OVER_VIEW_TAB_KEYS, LAYOUT_TYPE, LOCAL_STORAGE_KEYS, MANAGE_COLUMNS_VIEW_TYPES, DEFAULT_MANAGE_COLUMN_PROFILE_NAME
} from '../../utils/global_variables';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useWFHMessages } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { getFutureTabData, getFutureTabDataSuccess, resetCompanyContractInfo, resetMarketOverview, setAvailableExchangesData, updateSelectedArrRowData, updateSelectedConstituentView, setScripOverviewData } from '../../redux/actions/marketOverview';
import { getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell, getExchangeWiseScripInfo } from '../../redux/actions/orders';
import { sendBestFiveRequest, sendTouchlineRequest } from '../../apis/web_socket';
import { InlineScripSeach } from '../Search';
import {
    isUserIsAGuest, ORDER_ENTRY_GRID_REF, getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getMappedMktSegIdFromApiExchangeName,
    getScripDisplayDescription, setEncryptLocalStorage, createNewWatchlist, isGuestUser, generateUniqueName, bIsProd
} from '../../utils/global_functions';
import { clearOptionChain, openOptionChain, toggleOptionChainCheckBox, updateLegDataForOptionChain, updateObjMultiLegData } from '../../redux/actions/optionChain';
import moment from 'moment';
import { toastConfig } from '../../redux/actions/toast';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
import { updateFavoritesIndicesSuccess } from '../../redux/actions/indices'; //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
import { clearNewsState, clearNewsaDetailsStates } from '../../redux/actions/news';
import config from '../../config.json';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
import { updateDefaultManageColumnName, updateStrViewType } from '../../redux/actions/watchlist';
import _ from 'lodash';
const { TenantId } = config;

const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));


const MarketOverviewHeader = ({ isSpinner = () => { }, unsubScribOptionChainData, layoutType, handleMarketOverviewExpandOnclick, expandScripOverviewModel, selectedTab, setSelectedTab, setLastTab, chartOpened, handleChart }) => {

    const [bToggleSearchBar, setBToggleSearchBar] = useState(false); //BT-113338 Implementing header changes : ManasaB : 14/07/2023
    const dispatch = useDispatch();
    const [filterArrScripExchanges, setFilterArrScripExchanges] = useState([]);
    const [favouriteIndices, setFavouriteIndices] = useState([]);
    const arrFutureTabData = useSelector(state => state?.marketOverview?.arrFutureTabData);
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    //BT-114569:Functional Implementation:Vaibhav Singh:31-07-2023: holding data updation and exchange selector
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: Start
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: End
    const [currentHolding, setCurrentHolding] = useState([]);
    //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
    const isIndicesOverview = useSelector(state => state.indices.isIndicesOverview);
    const indiceOverviewData = useSelector(state => state.indices.indiceOverviewData);
    const userId = useSelector(state => state.auth.userId);
    const recommendations = useSelector(state => state.recommendation.recommendations);
    const [isDataPresent, setIsDataPresent] = useState(false);
    const modalData = useSelector(state => state?.modals?.modalData);
    //Vaibhav Singh: 09-11-23 : BT-109089 : Variables for dontmiss  : Start
    const { dontMissData } = useSelector(state => state.dontMiss);
    const [dontMissChip, setDontMissChip] = useState(false);
    //Vaibhav Singh: 09-11-23 : BT-109089 : Variables for dontmiss : End
    //Vaibhav Singh: BT-109089: 26-10-2023: Calling exchanges wise scripinfo on scripoverview data change
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing 
    const { watchlists, globalWatchlists } = useSelector(state => state?.watchList);

    const constituentsData = useSelector(state => state.marketOverview.constituentsData);
    const [objConstituent, setObjConstituent] = useState({});
    const selectedConstituentView = useSelector(state => state.marketOverview.constituentView);
    const [strConstituentView, setStrConstituentView] = useState(GRID_VIEW.DEFAULT_VIEW);

    useEffect(() => {
        if (!selectedConstituentView) {
            setStrConstituentView(GRID_VIEW.DEFAULT_VIEW);
        } else {
            setStrConstituentView(selectedConstituentView);
        }
    }, [selectedConstituentView]);
    useEffect(() => {
        if (modalData && modalData?.item?.sIndexDesc) {
            setObjConstituent(modalData?.item);
        } else { }
    }, [modalData]);
    useEffect(() => {
        dispatch(getExchangeWiseScripInfo(scripOverviewData));
    }, [scripOverviewData, dispatch]);
    useEffect(() => {
        if (userId) {
            const favourites = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.INDICES_FAVOURITE + '_' + userId));
            setFavouriteIndices(favourites || []);
        }
    }, [userId]);


    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            dispatch(getFutureTabData({
                symbol: scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL].replace(/\s+/g, "").toUpperCase(), instrument: scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK
                    //Azeem Khan : 28-05-2024 : BT-107249 -  Breeze – Scrip Overview: Futures Tab :Regression bug fixing- Start
                    : scripOverviewData?.[WATCHLIST_GRID_INDEX.EXCHANGE]?.includes('MCX') || scripOverviewData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTCOM
                        : scripOverviewData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTBLN
                            : 'FUT' + scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substr(3, 3)
                //Azeem Khan : 28-05-2024 : BT-107249 -  Breeze – Scrip Overview: Futures Tab :Regression bug fixing- End
            }));
        } else { }
    }, [dispatch, scripOverviewData]);
    //Vaibhav Singh: 09-11-23 : BT-109089 : Added DontmissLogic to be open from everywhere: Start
    useEffect(() => {
        const objDontMiss = dontMissData.find(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (objDontMiss !== undefined) {
            setDontMissChip(true);
        }
        else {
            setDontMissChip(false);
        }
    }, [dontMissData, scripOverviewData]);
    //Vaibhav Singh: 09-11-23 : BT-109089 : Added DontmissLogic to be open from everywhere: End
    //Vaibhav Singh: BT-109089: 26-10-2023: added holding data logic 
    //Vaibhav Singh : BT-109089 : 09-11-2023 : Holding Logic updated : Start
    useEffect(() => {
        if (holdingsScrips?.length || Object?.keys(holdingsScrips ? holdingsScrips : [])?.length) {
            let currHoldings = [];
            if (holdingsScrips?.status) {
                //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed: Start
                holdingsScrips?.result?.forEach((item, i) => {
                    if (item['ISIN'] === scripOverviewData[WATCHLIST_GRID_INDEX.ISIN_CODE] && scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                        currHoldings.push(item);
                    }
                });
            }
            else {
                holdingsScrips.forEach((item, i) => {
                    if (item['ISIN'] === scripOverviewData[WATCHLIST_GRID_INDEX.ISIN_CODE] && scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                        currHoldings.push(item);
                    }
                });
                //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed: End
            }
            setCurrentHolding(currHoldings);
        }
    }, [holdingsScrips, scripOverviewData]);
    //Vaibhav Singh : BT-109089 : 09-11-2023 : Holding Logic updated : End

    //AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - Start
    // SrikanthRao :06-02-2024 :  "bIsFutureAndOptionTab" Name changes for common usage FUTURE & OPTION_CHAIN TAB'S
    const bIsFutureAndOptionTab = useMemo(() => (arrFutureTabData?.length > 0 && scripOverviewData?.length > 0 && !scripOverviewData?.[WATCHLIST_GRID_INDEX?.INSTRUMENT]?.includes("UND"))
        || (scripOverviewData?.[WATCHLIST_GRID_INDEX?.IS_FO_EXIST] !== 0 && scripOverviewData?.[WATCHLIST_GRID_INDEX?.NSPREAD] === 0)
        , [scripOverviewData, arrFutureTabData]);
    //AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End
    //Azeem Khan : 28-05-2024 : BT-107249 -  Breeze – Scrip Overview: Futures Tab :Regression bug fixing- Start
    useEffect(() => {
        if (selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.FUTURES && !bIsFutureAndOptionTab) {
            setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW);
        }
    }, [bIsFutureAndOptionTab, scripOverviewData]);
    //Azeem Khan : 28-05-2024 : BT-107249 -  Breeze – Scrip Overview: Futures Tab :Regression bug fixing- End

    //Mahesh : 20-11-23 : BT-107375 -  Breeze – Scripinfo - Events: Evndts Tab - Start
    const bEventsTab = useMemo(() => (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_CASH || scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_CASH), [scripOverviewData]);
    //Mahesh : 20-11-23 : BT-107375 -  Breeze – Scripinfo - Events: Events Tab - End
    const [arrScripInformation, setArrScripInformation] = useState([]);
    const getEvent = useAnalyticsEventTracker('OVERVIEW');

    // {/*BT-114569:Functional Implementation:Vaibhav Singh:28-10-2023: Handle for Exchange dropdown change in MarketOverviewHeader Updated  */ }

    useEffect(() => {
        // Vaibhav SIngh: 04-11-2023: BT-109089: Scrip Overview: Fixing Issue on exchange toggle changes scrip - Start
        if (!isDataPresent && arrScripExchanges?.[0]?.[WATCHLIST_GRID_INDEX?.SYMBOL] === scripOverviewData?.[WATCHLIST_GRID_INDEX?.SYMBOL]) {
            // Vaibhav SIngh: 04-11-2023: BT-109089: Scrip Overview: Fixing Issue on exchange toggle changes scrip - End 
            const arrData = arrScripExchanges.filter((obj, i) => {
                return i === arrScripExchanges.findIndex(o => obj[WATCHLIST_GRID_INDEX.EXCHANGE] === o[WATCHLIST_GRID_INDEX.EXCHANGE]);
            });
            //Vaibhav Singh : BT-109089: 15-11-223: Fixed exchanges issue when segmen tis not allowed: Start 
            let exchangePresent = [];
            arrData?.forEach((ele, ind) => {
                if (ele[WATCHLIST_GRID_INDEX.EXCHANGE] === scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]) {
                    arrData.unshift(arrData.splice(ind, 1)[0]);
                    setIsDataPresent(true);
                }
                exchangePresent.push(ele[WATCHLIST_GRID_INDEX.EXCHANGE]);
            });
            if (!exchangePresent?.includes(scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE])) {
                arrData?.unshift(scripOverviewData);
                setIsDataPresent(true);
            }
            setFilterArrScripExchanges(arrData);
            // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- Start
            dispatch(setAvailableExchangesData(arrData));
            // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- End
            //Vaibhav Singh : BT-109089: 15-11-223: Fixed exchanges issue when segmen tis not allowed: End
        }
    }, [arrScripExchanges, dispatch]);
    //BT-113692 : Function For Holdings Upadtion : Vaibhav Singh : 19-08-2023 


    const handleExchange = (e) => {
        if (filterArrScripExchanges?.length) {
            filterArrScripExchanges?.forEach((item) => {
                if (e === item[WATCHLIST_GRID_INDEX.EXCHANGE]) {
                    // dispatch(resetMarketOverview());
                    dispatch(resetCompanyContractInfo());
                    dispatch(setScripOverviewData(item));
                }
            });
        }
    };
    const handleArrGridRowData = (segmentId, token, e) => {
        const detail = [...e.detail];
        if (segmentId === detail[BEST5_INDEX.SEGMENT_ID] && token === detail[BEST5_INDEX.TOKEN]) {
            //By HiralK : 06-09-2023 : For Price optimization - Start
            detail[BEST5_INDEX.LAST_TRADE_PRICE] = (detail[BEST5_INDEX.LAST_TRADE_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            //detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
            //By HiralK : 06-09-2023 : For Price optimization - End
            setArrScripInformation(detail);
        }
    };
    const handleSelectScripFromGlobalSearch = (arrScrip) => {
        if (selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN) {
            let srikepriceElement = document.getElementById('optionchain-strikeprice');
            if (srikepriceElement) {
                srikepriceElement.value = "0.00"
            }
            // unSubscribe previous scrips
            unsubScribOptionChainData()?.then(() => {
                dispatch(updateLegDataForOptionChain());
                dispatch(updateObjMultiLegData({}));
                dispatch(clearOptionChain());
                let symbol;
                let location;
                if (isIndicesOverview) {
                    location = OPTION_CHAIN.INDICES;
                    symbol = arrScrip[WATCHLIST_GRID_INDEX.DISPLAY_DESC];
                } else {
                    symbol = arrScrip[WATCHLIST_GRID_INDEX.SYMBOL];
                    location = OPTION_CHAIN.OVERVIEW;
                }
                setTimeout(() => {
                    dispatch(openOptionChain({
                        expiryDate: arrScrip[WATCHLIST_GRID_INDEX?.EXPIRYDATE],
                        instrumentName: arrScrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
                        symbol: symbol, instrument: arrScrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
                        id: arrScrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
                        token: arrScrip[WATCHLIST_GRID_INDEX.TOKEN],
                        bestFive: true,
                        location: location,
                        mappedId: arrScrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                        assetToken: arrScrip[WATCHLIST_GRID_INDEX.ASSET_TOKEN] !== 0 ? arrScrip[WATCHLIST_GRID_INDEX.ASSET_TOKEN] : arrScrip[WATCHLIST_GRID_INDEX.TOKEN]
                    }));
                }, 500);

            });

        }
        dispatch(resetMarketOverview());
        setFilterArrScripExchanges([]);
        dispatch(setScripOverviewData([...arrScrip]));
        setIsDataPresent(false);
        setBToggleSearchBar(false);   //BT-113338 Implementing header changes ManasaB : 15/07/2023 - Start 
        //vaibhav Singh: 16-11-23: BT-109089: Emptied the cureentholding on scripchange: Start
        setCurrentHolding([]);
        //vaibhav Singh: 16-11-23: BT-109089: Emptied the cureentholding on scripchange: End
        //Vaibhav Singh: 14-12-23: BT-107248: toggling both contract and company info fixed: Start
        if (selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.COMPANY_INFO || selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.CONTRACT_DETAILS) {
            if (arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID] !== '1' && arrScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID] !== '3') {
                setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.CONTRACT_DETAILS);
            } else {
                setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.COMPANY_INFO);
            }
        }
        //Vaibhav Singh: 14-12-23: BT-107248: toggling both contract and company info fixed: End
    };

    useWFHMessages('bestfive', (e) => {
        handleArrGridRowData(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], e);
    });



    useEffect(() => {
        if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE] = (parseFloat(arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE]));
                arrLastTickScripData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = (arrLastTickScripData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]); // Hari: 29-07-2023 show LTP change in recommendations scrip overview
                setArrScripInformation([...arrLastTickScripData]);
            } else { }
        } else { }
    }, [dispatch, scripOverviewData]);

    // const bShowEvents = useMemo(() => (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.MCX_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSX_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECDX_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES ||
    //     scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES),
    //     [scripOverviewData]);

    const marketOverviewTabs = useMemo(() => [
        {
            tabTitle: isIndicesOverview && 'Constituents',
            tabKey: 'constituents'
        },
        {
            tabTitle: 'Overview',
            tabKey: 'overview'
        },
        {
            tabTitle: bEventsTab && !isIndicesOverview && 'Events',//Mahesh : 20-11-23 : BT-107375 -  Breeze – Scripinfo - Events: to show events tab for scrips added
            tabKey: 'events'
        },
        {
            tabTitle: !isIndicesOverview && recommendations?.filter((each) => (each?.nSegmentId + "_" + each?.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]).length > 0 && 'Recommendations',
            tabKey: 'recommendations'
        },
        {
            tabTitle: !isIndicesOverview && 'Analysis',
            tabKey: 'analysis'
        },
        {
            tabTitle: (bIsFutureAndOptionTab || isIndicesOverview) && 'Futures',
            tabKey: 'futures'
        },
        {
            tabTitle: (bIsFutureAndOptionTab || isIndicesOverview) && 'Option Chain',
            tabKey: 'option_chain'
        },
        (scripOverviewData && scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS?.EQUITIES ? //Added ScripOverviewData&& condition : ManasaB : 13/07/23
            {
                tabTitle: !isIndicesOverview && 'Company Info',
                tabKey: 'company_info'
            } :
            {
                tabTitle: !isIndicesOverview && 'Contract Information',
                tabKey: 'contract_details'
            })
    ], [bIsFutureAndOptionTab, isIndicesOverview, scripOverviewData, recommendations]);



    const handleTabs = useCallback((tabKey) => {
        dispatch(toggleOptionChainCheckBox(false));
        dispatch(updateObjMultiLegData({}));
        if (tabKey === MARKET_OVER_VIEW_TAB_KEYS?.ANALYSIS && isGuestUser()) {
            isUserIsAGuest(MARKET_OVER_VIEW_TAB_KEYS?.ANALYSIS);
        } else {
            if (tabKey === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN && !isGuestUser()) {
                let symbol;
                let location;
                if (isIndicesOverview) {
                    location = OPTION_CHAIN.INDICES;
                    symbol = scripOverviewData[WATCHLIST_GRID_INDEX.DISPLAY_DESC];
                } else {
                    symbol = scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL];
                    location = OPTION_CHAIN.OVERVIEW;
                }
                dispatch(openOptionChain({
                    expiryDate: scripOverviewData[WATCHLIST_GRID_INDEX?.EXPIRYDATE],
                    instrumentName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                    symbol: symbol, instrument: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                    id: scripOverviewData[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
                    token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                    bestFive: true,
                    location: location,
                    mappedId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                    assetToken: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] !== 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]
                }));

            } else if (tabKey === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN && isGuestUser()) {
                isUserIsAGuest('option_chain')
            }

            if (tabKey !== MARKET_OVER_VIEW_TAB_KEYS?.EVENTS) {
                dispatch(clearNewsaDetailsStates());
                dispatch(clearNewsState());
            }
            setSelectedTab(tabKey);
            setLastTab(tabKey);
        }
        isSpinner(false);
    }, [dispatch, setLastTab, setSelectedTab, isIndicesOverview, scripOverviewData]);

    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - Start

    useEffect(() => {
        if (modalData.tab === MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW || modalData.tab === MARKET_OVER_VIEW_TAB_KEYS?.ANALYSIS) {
            setSelectedTab(modalData.tab);
            delete modalData.tab;
            dispatch(handleModalData(modalData));
        }
    }, [modalData, dispatch]);
    //AzeemKhan :25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End


    const debounceChange = useCallback(_.debounce(handleTabs, 2000), []);

    const handleTabChange = useCallback((e) => {

        let key = e?.key;
        let shiftKey = e?.shiftKey;
        let arr = marketOverviewTabs.filter(x => x?.tabTitle);
        let index = arr.findIndex(x => x?.tabKey === selectedTab);

        if (key === "Tab") {
            e?.preventDefault();
            if (shiftKey) {
                e?.preventDefault();
                if (index === 0) {
                    setSelectedTab(arr[index]?.tabKey);
                    debounceChange(arr[index]?.tabKey);
                } else {
                    setSelectedTab(arr[index - 1]?.tabKey);
                    debounceChange(arr[index - 1]?.tabKey);
                }
            } else {
                if (index === arr?.length - 1) {
                    setSelectedTab(arr[index]?.tabKey);
                    debounceChange(arr[index]?.tabKey);
                } else {
                    setSelectedTab(arr[index + 1]?.tabKey);
                    debounceChange(arr[index + 1]?.tabKey);
                }
            }
            isSpinner(true);
        }

    }, [selectedTab, marketOverviewTabs]);

    useEffect(() => {
        document.addEventListener('keydown', handleTabChange);
        return () => {
            document.removeEventListener('keydown', handleTabChange);
        };
    }, [handleTabChange]);


    const onHide = () => {
        dispatch(updateSelectedArrRowData([]));
        dispatch(updateLegDataForOptionChain());
        dispatch(updateObjMultiLegData({}));
        dispatch(clearOptionChain());
        unsubScribOptionChainData();
        // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }], true));
        } else {
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }], true));
        }
        // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End
        setSelectedTab('constituents');
        dispatch(getFutureTabDataSuccess([]));
        sendBestFiveRequest({ exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false }); //Hari: unsubscribing the scrip while closing overview modal
        if (expandScripOverviewModel) {
            handleMarketOverviewExpandOnclick(); //Vaibhav Singh : BT-116978 : 01-09-2023 : Scrip Window maximise issue fixed for toggle if window is maximised
        }
    };

    const handleExpand = () => {
        handleMarketOverviewExpandOnclick();
    };


    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const setOrderEntryScripPrice = (activeButtonToggleIndex) => {
        const nAskPrice = parseFloat(arrScripInformation[BEST5_INDEX.SELL_PRICE_1]);
        const nLTP = parseFloat(arrScripInformation[BEST5_INDEX.LAST_TRADE_PRICE]);
        const nBidPrice = parseFloat(arrScripInformation[BEST5_INDEX.BUY_PRICE_1]);
        if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
            if (nAskPrice > 0) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nAskPrice }));
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
            }
        } else {
            if (nBidPrice > 0) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nBidPrice }));
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
            }
        }
    };

    const handlePlaceOrder = async (nIsBuyOrSell = 0) => {
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: scripOverviewData }));
        setOrderEntryScripPrice(nIsBuyOrSell);
        await dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }]));
    };
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    //Prachi Tawde - BT-109089 Breeze - Scrip Overview – Overview - Opening Order entry from overview - Start
    const onBuySellClick = (strBuySell) => {
        getEvent(`${strBuySell === 'BUY' ? 'B' : 'S'}_SCRIPINFO`);
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: Start
            const strExchangeName = getApiExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
                if (scripOverviewData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    handleSelectSpreadOrderModel(scripOverviewData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry 
                } else {
                    handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1);
                }
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `You are currently not allowed to place/modify/cancel order in this segment` }));
            }
            // Vaibhav Singh: BT-109089: 16-11-23: If exchange not allowed BUY/SELL will not open: End 
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End


    };
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        sendTouchlineRequest([
            { exchangeId: spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: spreadArr[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },

        ]);
        dispatch(getSpreadOrder(spreadPaylod));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }, true]));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
    };


    //Prachi Tawde - BT-109089 Breeze - Scrip Overview – Overview - Opening Order entry from overview - End
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - Start
    const handleSearch = () => {
        setBToggleSearchBar(!bToggleSearchBar);
    };
    const inputRef = useRef();
    const modals = useSelector(state => state.modals.modals);
    useEffect(() => {
        const escFunction = (event) => {
            if (event.keyCode === 27) {

                if (document.activeElement === inputRef.current) {
                    setBToggleSearchBar(false);
                    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - Start
                } else if (modals['GLOBAL_SEARCH_ADDSCRIP_MODAL'] === true) {
                    dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": false }]));

                } else if (modals['SET_ALERT_MODAL'] === true) {
                    dispatch(handleModal([{ "SET_ALERT_MODAL": false }]));
                    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End

                } else if (modals['RECOMMENDATION_FOLLOW_UP_MODAL'] === true) {// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    dispatch(handleModal([{ 'RECOMMENDATION_FOLLOW_UP_MODAL': false }]));// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                } else if (modals['WATCHLIST_NAMING_MODAL'] === true) {// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    dispatch(handleModal([{ 'WATCHLIST_NAMING_MODAL': false }]));// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                } else if (modals['GLOBAL_WATCHLIST_SCRIPT_MODAL'] === true) {// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    dispatch(handleModal([{ 'GLOBAL_WATCHLIST_SCRIPT_MODAL': false }]));// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                } else if (modals['CORPORATE_ACTIONS_DETAILS'] === true) {
                    dispatch(handleModal([{ "CORPORATE_ACTIONS_DETAILS": false }]));
                    //Hari k : 25-09-2024 : Breeze – Scrip Overview: events Tab  - End
                } else if (modals['NEWS_DETAILS'] === true) {
                    dispatch(handleModal([{ "NEWS_DETAILS": false }]));
                } else if (modals['HOT_PURSUIT_DATA'] === true) {
                    dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }]));
                } else if (modals['WATCHLIST_MANAGE_COLUMNS_MODAL'] === true) {
                    dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": false }]));
                }
                else {
                    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
                }
            };
        };
        document.addEventListener('keydown', escFunction);
        return () => {
            document.removeEventListener('keydown', escFunction);
        };
    }, [modals, dispatch]);
    //BT-109095: Functional Implementation : Vaibhav Singh : 27-07-2023 : Click Event listener to check if inline-search toggle on/off updated contains to matches to include click on child classes 
    useEffect(() => {
        //Vaibhav Singh: 11-12-23: inline Search wrap added under scroll: Start
        const clickFunction = (event) => {
            if (!inputRef?.current?.contains(event.target) && !event.target.matches('.inline-search-scrip-list, .inline-search-wrap, .inline-search-scrip-list *')) {
                setBToggleSearchBar(false);
            }
        };
        //Vaibhav Singh: 11-12-23: inline Search wrap added under scroll: End
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, []);
    //BT-109095: Functional Implementation : Vaibhav Singh : 26-07-2023 : Added to get PopOverName inside overview modal
    const OverviewPopOverName = useCallback(() => {
        if ((scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
            return (<div className='font-regular font-size4 color-subtext'>{`${scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${scripOverviewData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
        } else if (!scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            !scripOverviewData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
            return (<div className='d-flex align-items-center'><div className='font-regular font-size4 color-subtext'>{scripOverviewData[WATCHLIST_GRID_INDEX.SERIES]}</div></div>);
        }
        else if (scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !scripOverviewData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
            return (
                <div className='font-regular font-size4 color-subtext'>{`${scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${scripOverviewData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
            );
        } else {
            return null;
        }
    }, [scripOverviewData]);
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 - End

    const favouriteHandler = (selectedIndice, isCheck) => {
        if (!DEFAULT_FAVOURITE_INDICES?.includes(`${selectedIndice?.nMarketSegmentId}_${selectedIndice?.nToken}`)) {
            if (isCheck === true) {
                selectedIndice['isFavourite'] = true;
                if (selectedIndice?.country) {
                    selectedIndice['isGlobal'] = true;
                }
                setFavouriteIndices([...favouriteIndices, selectedIndice]);
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.INDICES_FAVOURITE + '_' + userId, JSON.stringify([...favouriteIndices, selectedIndice]));
                dispatch(updateFavoritesIndicesSuccess([...favouriteIndices, selectedIndice])); //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
            }
            else if (isCheck === false) {
                let updatedFavourites = [...favouriteIndices];
                if (selectedIndice?.isGlobal) {
                    updatedFavourites = favouriteIndices.filter(favourite => favourite?.IndexID !== selectedIndice?.IndexID);
                }
                else {
                    updatedFavourites = favouriteIndices?.filter(favourite => favourite.nMarketSegmentId !== selectedIndice.nMarketSegmentId || favourite.nToken !== selectedIndice.nToken);
                }
                setFavouriteIndices([...updatedFavourites]);
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.INDICES_FAVOURITE + '_' + userId, JSON.stringify([...updatedFavourites]));
                dispatch(updateFavoritesIndicesSuccess([...updatedFavourites])); //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
            } else { }
        } else { }
    };
    //Vaibhav Singh : BT-109089: 24-10-2023: Add to wathclist logic 
    const handleAddToWatchlist = () => {
        dispatch(setArrScripToBeAdded([scripOverviewData]));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
    };
    //Vaibhav Singh: BT-109089: 24-10-2023: Logic for set ALert added 
    const handleSetAlert = () => {
        getEvent('ALERT_SCRIPINFO');
        dispatch(handleModalData({
            AlertData: {
                symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL],
                exchange: scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE],
                series: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
                //isExpiry ? strFutureExpiry : 
                description: getScripDisplayDescription(scripOverviewData),
                token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                mktId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                decimalLocator: scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocator_length: scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                exchange_segement: getApiExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID])
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };

    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - Start
    useEffect(() => {
        const arrRecommendations = recommendations?.filter((each) => (each?.nSegmentId + "_" + each?.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (selectedTab === MARKET_OVERVIEW_TABS.RECOMMENDATIONS && !arrRecommendations?.length) {
            setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW);
        }
    }, [selectedTab, recommendations, scripOverviewData, setSelectedTab]);
    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - End

    const [showAddWatchlist, setShowAddWatchlist] = useState(false);
    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    const handleCreateWatchlist = () => {
        const arrScrips = constituentsData?.map((eachScrip) => {
            return { nMarketSegmentId: eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], nToken: eachScrip[WATCHLIST_GRID_INDEX.TOKEN] };
        });
        let wathlistToSearch = scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL];
        const suffixName = generateUniqueName(wathlistToSearch, globalWatchlists, watchlists);
        createNewWatchlist(objLoginSession, arrScrips, "static", TenantId, suffixName, "constituent", dispatch);
    };

    useEffect(() => {
        const arrScrips = constituentsData?.map((eachScrip) => {
            return { nMarketSegmentId: eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], nToken: eachScrip[WATCHLIST_GRID_INDEX.TOKEN] };
        })?.filter((value) => {
            if (value?.nMarketSegmentId !== undefined) {
                return value;
            } else { }
        });
        if (arrScrips?.length > 0) {
            setShowAddWatchlist(false);
        } else {
            setShowAddWatchlist(true);
        }
    }, [constituentsData]);
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end



    useEffect(() => {
        inputRef?.current?.focus();
    }, []);

    const arrKababDropdown = [
        ...(strConstituentView == "Default view" ? [{ id: '0', value: '0', content: 'Manage Columns' }] : []),
        // { id: '1', value: '1', content: 'Reorder scrips' },
        { id: '2', value: '2', content: 'Default view' },
        { id: '3', value: '3', content: 'Price/Volume view' },
        ...(!bIsProd ? [{ id: '4', value: '4', content: 'Heatmap view', shortcut: 'F5' }] : []),
    ];

    const arrfuturesdropdown = [
        { id: '0', value: '0', content: 'Manage Columns' },
    ]
    const futureKababDropdownoptionsOnClickHandler = useCallback((value) => {
        dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.FUTURES))
        switch (value) {
            case '0': {
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE));
                dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
            }
            default:
                break;
        }
    }, [dispatch])

    const kababDropdownoptionsOnClickHandler = useCallback((value) => {
        switch (value) {
            case '0': {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.CONSTITUENT))
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE));
                dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
            }
            case '2': {
                dispatch(updateSelectedConstituentView(GRID_VIEW.DEFAULT_VIEW));
                break;
            }
            case '3': {
                dispatch(updateSelectedConstituentView(GRID_VIEW.PRICE_VOLUME_VIEW));
                break;
            }
            case '4': {
                dispatch(updateSelectedConstituentView(GRID_VIEW.HEAT_MAP));
                break;
            }
            // need to give one case to open manage columns modal
            default:
                break;
        }
    }, [dispatch]);

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex justify-content-end'>
                        <BzToolTip placement={expandScripOverviewModel ? 'left' : 'top'} TooltipMsg={expandScripOverviewModel ? 'Collapse' : 'Expand'}><div className={`icon-16 icon-dark  me-4 ${expandScripOverviewModel ? "icon-collapse" : "icon-expand"}`} onClick={handleExpand}></div></BzToolTip>
                        <BzToolTip placement={expandScripOverviewModel ? 'bottom' : 'right'} TooltipMsg={"Close"}><div className='icon-16 icon-dark icon-close' onClick={onHide}>&nbsp;</div></BzToolTip>
                    </Col>
                </Row>

                <Row className='g-0 pt-3 pb-2 align-items-center'>
                    <Col md={7}>
                        <div className={`${expandScripOverviewModel ? 'd-flex' : 'flex-column'}`}>
                            <div className='d-flex align-items-center'>
                                {bToggleSearchBar ?
                                    (
                                        <InlineScripSeach ref={inputRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} />)
                                    : <>
                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                        {!isIndicesOverview &&
                                            <div className='font-medium font-size4 color-subtext text-uppercase me-2'><OverviewPopOverName /></div>}
                                        {isIndicesOverview ?
                                            <></>
                                            :
                                            <>
                                                <div className='icon-16 icon-search icon-dark' onClick={handleSearch}></div>
                                                <div className='screen-dropdown mx-2'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle className='btn-default'>{scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {
                                                                arrScripExchanges?.length && filterArrScripExchanges?.length ? filterArrScripExchanges?.map((item, index) => (
                                                                    <Dropdown.Item key={index} onClick={() => handleExchange(item[WATCHLIST_GRID_INDEX.EXCHANGE])}>{item[WATCHLIST_GRID_INDEX.EXCHANGE]}</Dropdown.Item>
                                                                ))
                                                                    : scripOverviewData?.length ? <Dropdown.Item>{scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}</Dropdown.Item> : null
                                                            }
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                            <div className='d-flex justify-content-start align-items-center'>
                                <>
                                    <div className={`font-medium font-size6 color-text me-1`}>{(arrScripInformation?.length) ? arrScripInformation?.[BEST5_INDEX.LAST_TRADE_PRICE] : scripOverviewData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] || 0?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}</div>
                                    <div className={`font-regular font-size4 color-text ${arrScripInformation?.length ? parseFloat(arrScripInformation?.[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) > 0 ? 'color-positive' : parseFloat(arrScripInformation?.[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-negative' : parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]) > 0 ? 'color-positive' : parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] || 0?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])) === 0 ? 'color-text' : 'color-negative'}`}>
                                        <span>{arrScripInformation?.length ? arrScripInformation?.[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] : scripOverviewData?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] || 0?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}</span>
                                    </div>
                                    <div className={`font-regular font-size4 color-text ms-1 ${arrScripInformation?.length ? parseFloat(arrScripInformation?.[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) > 0 ? 'color-positive' : parseFloat(arrScripInformation?.[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-negative' : parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.LTP_PERCENT]) > 0 ? 'color-positive' : parseFloat(scripOverviewData?.[WATCHLIST_GRID_INDEX.LTP_PERCENT] || 0?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])) === 0 ? 'color-text' : 'color-negative'}`}>
                                        <span>({arrScripInformation?.length ? arrScripInformation?.[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE] : scripOverviewData?.[WATCHLIST_GRID_INDEX.LTP_PERCENT] || 0?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}%)</span>
                                    </div>
                                    {
                                        isIndicesOverview ? <div className='font-regular font-size2 color-subtext ms-2'>{moment(Date.now()).format('DD MMM \'YY hh:mm:ss A')}</div>
                                            : null
                                    }
                                </>
                                {isIndicesOverview ?
                                    !modalData?.header ? <BzToolTip placement='top' TooltipMsg='Favourite'>
                                        {favouriteIndices?.some(element => scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === `${element.nMarketSegmentId}_${element.nToken}`) ?
                                            <div className='icon-20 icon-favourites-fill icon-negative ms-3' onClick={() => favouriteHandler(indiceOverviewData, false)}></div> :
                                            <div className='icon-20 icon-favourites icon-dark ms-3' onClick={() => favouriteHandler(indiceOverviewData, true)}></div>
                                        }
                                    </BzToolTip> : null
                                    : null
                                }
                                {scripOverviewData && dontMissChip ?
                                    <>
                                        <div className='icon-16 icon-dontmiss icon-yellow ms-2'></div>
                                    </>
                                    : null
                                }

                                {(currentHolding?.length && parseInt(currentHolding?.[0]?.['TOTALFREEQUANTITY']) > 0) ?
                                    <>
                                        {(currentHolding?.length) ? <div className='icon-16 icon-dark icon-portfolio ms-2'> </div> : null}
                                    </>
                                    : null
                                }

                            </div>
                        </div>
                    </Col>
                    <Col md={5} className='d-flex justify-content-end align-items-center'>
                        <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                            <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleChart}>
                                <div class="icon-20 icon-graph icon-primary"></div>
                            </button>
                        </BzToolTip>
                        {!isIndicesOverview ?
                            <>{objCFT.ALERT === FACILITY_NUM.ON ?
                                <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                    <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleSetAlert}>
                                        <div class="icon-20 icon-alert icon-primary"></div>
                                    </button>
                                </BzToolTip> : null}
                                <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                    <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-3' onClick={handleAddToWatchlist}>
                                        <div class="icon-20 icon-add-circle icon-primary"></div>
                                    </button>
                                </BzToolTip>
                            </>
                            : null}
                        {
                            !isIndicesOverview && <>
                                <BzButton className='btn btn-md btn-positive text-capitalize me-2' onClick={onBuySellClick.bind(this, 'BUY')}>BUY</BzButton>
                                <BzButton className='btn btn-md btn-negative text-capitalize' onClick={onBuySellClick.bind(this, 'SELL')}>SELL</BzButton>
                            </>
                        }
                        {selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS ?
                            <BzButton className={`btn btn-sm btn-outline d-flex align-items-center ${showAddWatchlist ? 'div-disabled' : ''}`} onClick={handleCreateWatchlist}>
                                <div class="icon-12 icon-add icon-primary me-2"></div>
                                <span className='font-medium'>Watchlist</span>
                            </BzButton>
                            : null}
                    </Col >
                </Row >

                <div className='clear'></div>
                {
                    (!chartOpened) ?
                        <Row className='g-0'>
                            <Col>
                                <BzTabs className='nav nav-tabs horizontal-scroll-wrap pt-2 z-index'>
                                    {
                                        marketOverviewTabs?.length && marketOverviewTabs.map((tab, index) => {
                                            return tab?.tabTitle && <BzTab key={index} onClick={handleTabs.bind(this, tab?.tabKey)} className='nav-link text-capitalize' isActive={selectedTab == tab?.tabKey} tabKey={tab?.tabKey}>{index === 0 ?
                                                <div className='d-flex align-items-center'>
                                                    <Dropdown className='dropdown-kebab'>
                                                        <Dropdown.Toggle as={CustomDropdownToggle}>
                                                            <div className='d-flex align-items-center'>
                                                                <span>{tab?.tabTitle}</span>
                                                                <span className='icon-14 icon-kebab icon-dark flex-shrink-0'></span>
                                                            </div>                                                            
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {
                                                                arrKababDropdown?.map((eachOption) => (
                                                                    <Dropdown.Item disabled={eachOption.id === "0" && strConstituentView !== "Default view" ? true : false} key={eachOption.id} value={eachOption.value} onClick={() => kababDropdownoptionsOnClickHandler(eachOption.value)}>
                                                                        <Container fluid className='p-0'>
                                                                            <Row className='g-0' >
                                                                                <Col md={12} className='d-flex justify-content-between align-self-center'>
                                                                                    <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                                                    {strConstituentView === eachOption.content && <div className='icon-16 icon-checktick icon-primary'></div>}
                                                                                </Col>
                                                                            </Row>
                                                                        </Container>
                                                                    </Dropdown.Item>
                                                                ))
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown></div> :
                                                index === 5 ?
                                                    <div className='d-flex align-items-center'>
                                                        <Dropdown className='dropdown-kebab'>
                                                            <Dropdown.Toggle as={CustomDropdownToggle}>
                                                                <div className='d-flex align-items-center'>
                                                                    <span>{tab?.tabTitle}</span>
                                                                    <span className='icon-14 icon-kebab icon-dark flex-shrink-0'></span>
                                                                </div>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {
                                                                    arrfuturesdropdown?.map((eachOption) => (
                                                                        <Dropdown.Item key={eachOption.id} value={eachOption.value} onClick={() => futureKababDropdownoptionsOnClickHandler(eachOption.value)}>
                                                                            <Container fluid className='p-0'>
                                                                                <Row className='g-0' >
                                                                                    <Col md={12} className='d-flex justify-content-between align-self-center'>
                                                                                        <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                                                        {/* {strConstituentView === eachOption.content && <div className='icon-16 icon-checktick icon-primary'></div>} */}
                                                                                    </Col>
                                                                                </Row>
                                                                            </Container>
                                                                        </Dropdown.Item>
                                                                    ))
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown></div>
                                                    : tab?.tabTitle}</BzTab>;
                                        })
                                    }
                                </BzTabs>
                            </Col>

                        </Row>
                        :
                        null}
            </Container >
        </>
    );
};

export default memo(MarketOverviewHeader);